export default __webpack_public_path__ + "static/media/img-0759-slovenia-full-face.05bc0d92.png";